"use strict"; // Start of use strict
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = js_swiper_url;
  s.async=true;
  s.onload = function(){ init_carousel();};
  document.getElementsByTagName('head')[0].appendChild(s);

  function init_carousel(){
      var swiper = new Swiper(".mySwiper", {
        slidesPerView: 2,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        },
      });
    
      var swiper = new Swiper(".slide-Swiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
        },
      });
      
    var swiper = new Swiper(".collection-slide-Swiper", {
        slidesPerView: 3,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
       autoplay: {
          delay: 3000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 15,
          },
        },
      });

    var swiper = new Swiper(".brand-slide-Swiper", {
        slidesPerView: 4,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 3000,
        },
        loop: true,
        breakpoints: {
          640: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        },
      });

    var swiper = new Swiper(".video-gallery-swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
      });

      var swiper = new Swiper(".best-seller-swiper", {
        slidesPerView: 1,
        spaceBetween: 2,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next-1",
          prevEl: ".swiper-button-prev-1",
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 2,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
        },
      });

    const sliderElement = document.querySelector('.slider_option');
    if (sliderElement) {

      const sliderOptions = JSON.parse(sliderElement.getAttribute('data-slider-options'));
      // Access the auto_play value
      const autoPlayValue = sliderOptions.auto_play;
      let autoplay = false;
      if (autoPlayValue > 0) {
        autoplay = {
          delay: autoPlayValue * 1000,
        };
      }
      let loop = false;
      if (sliderOptions.loop === 'true' || sliderOptions.loop === true) {
        loop = true;
      }
      
      var swiper = new Swiper(".home-slide-Swiper", {
          slidesPerView:1,
          spaceBetween: 1,
          init: false,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay,
          loop,
          navigation: {
            nextEl: ".swiper-button-next-10",
            prevEl: ".swiper-button-prev-10",
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 1,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 1,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 1,
            },
          },
           effect: sliderOptions.effect,
        });
      
        swiper.on('init', function () {
            const activeSlide = swiper.slides[swiper.activeIndex];
            if (activeSlide.classList.contains('is_video_slide')) {
                const modalId = activeSlide.getAttribute("data-modal-id");
                const index = activeSlide.getAttribute("data-index");
                const modalElement = document.getElementById(modalId);
                if (modalElement) {
                    setTimeout(() => {
                        modalElement.click(); // Trigger the modal
                        const video = document.getElementById("myVideo-" + index);
                        if (video) {
                            video.muted = true; // Mute for autoplay
                            modalElement.style.display = "none";
                            video.play().then(() => {
                                video.removeAttribute('controls'); // Remove controls after play starts
                            }).catch((error) => {
                                console.error("Autoplay failed:", error);
                            });
                        }
                    }, 1000); // 2-second delay for video play
                }
            }
        });
        swiper.on('slideChange', function () {
          const activeSlide = this.slides[this.activeIndex];
           if (activeSlide.classList.contains('is_video_slide')) {
              const modalId = activeSlide.getAttribute("data-modal-id");
              const index = activeSlide.getAttribute("data-index");
              const modalElement = document.getElementById(modalId);
              if (modalElement) {
                  setTimeout(() => {
                      modalElement.click(); // Trigger the modal
                      var video = document.getElementById("myVideo-"+index);
                      if (video) {
                          video.muted = true; // Mute video for autoplay
                          modalElement.style.display = "none";
                          video.play().then(() => {
                              video.removeAttribute('controls'); // Remove controls after playback starts
                          }).catch((error) => {
                              console.error("Autoplay failed:", error);
                          });
                      }
                  }, 1000); // 2-second delay
              }
          }
          // Pause video on all other slides
          swiper.slides.forEach((slide, slideIndex) => {
              if (slideIndex !== swiper.activeIndex && slide.classList.contains('is_video_slide')) {
                  const index = slide.getAttribute("data-index");
                  const video = document.getElementById("myVideo-" + index);
                  if (video && !video.paused) {
                      video.pause();
                      video.currentTime = 0; // Reset video to the beginning
                  }
              }
          });
      });
      swiper.init();
    }
  }

  function initNewsletters() {
      if (localStorage.getItem("popup-call") === null) {
        var count = 3; // set secconds
        var counter = setTimeout(function() {
          var element = document.getElementById("newsletterModal");
          element.classList.add("show");      
          element.classList.add("popupshow");  
           localStorage.setItem('popup-call', 1);
           closeModel();
        }, 1000 * count);
      }
  }

function closeModel(){
    const popup = document.getElementById('model-close')
    popup.addEventListener('click', (event) => {
      var element = document.getElementById("newsletterModal");
      element.classList.remove("show");      
      element.classList.remove("popupshow");
  }); 
}

function playVideo(){
  var counter = setTimeout(function() {
      let vid = document.getElementById("playvideo");
      if(vid) {
         vid.click();
        var w = window.innerWidth;
        if(w < 591){
          document.getElementById("deferred_media_video").style.ratiopercent = "56";
        }
         document.querySelector('video').setAttribute('oncontextmenu', "return false;");
      }
    }, 1000 * 5);
}

document.addEventListener("DOMContentLoaded",function(){
  playVideo();
});

//////


  $(document).ready(function () {
    $(".testimonial_slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: false,
      arrows: true,
      appendArrows: $('.testimonial_slider_arrow_box'),
      nextArrow: '<a class="testimonial_pre_arrow"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
      prevArrow: '<a class="testimonial_pre_arrow"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 1500,
            dots: false,
            arrows: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 1500,
            dots: false,
            arrows: true,
          },
        },
        {
          breakpoint: 540,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 1500,
            dots: false,
            arrows: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 1500,
            dots: false,
            arrows: true,
          },
        },
      ],
    });
  });
